import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import {TeamMember} from "./TeamMember";
import type {IPaginated} from "../IPaginated";

export class Team implements IPaginated<TeamMember> {
  @autoserializeAsArray(() => TeamMember)
  public readonly entries: readonly TeamMember[];
  @autoserializeAs(() => Number)
  public readonly total: number;
}
